import { getRecommendations } from 'common/__content-api/v4/get-recommendations'
import { isFeatureEnabled } from 'common/feature-togglings/features'

import { DataLoaderGlobalParams } from 'common/data/resources'
import { getMetadata } from 'component-library/content/Video/utils/get-metadata'
import { shuffleArray } from 'common/helpers/shuffle'
import { PlaylistType, VideoQueueItemMeta } from 'common/events/video-event-types'

export interface VideoQueue {
    items: VideoQueueItemMeta[]
    type: PlaylistType
}

export type VideoQueueItem = VideoQueueItemBasic | VideoQueueItemMeta

export interface VideoQueueItemBasic {
    id: string
    accountId: string
}

export function isVideoItemWithMeta(videoItem: VideoQueueItem): videoItem is VideoQueueItemMeta {
    return (videoItem as VideoQueueItemMeta).name !== undefined
}

/**
 * Gets the video queue for a publication based on it's topics
 */
export async function getVideoQueue(
    services: DataLoaderGlobalParams,
    publicationId: string
): Promise<VideoQueue> {
    const apiVideoListing = await getRecommendations(services, {
        publicationId,
    })

    if (
        apiVideoListing.shortform.length > 0 &&
        isFeatureEnabled(services.store.getState().toggles, 'use-oovvuu-recommendation')
    ) {
        const videoQueuePopulated = await Promise.all(
            apiVideoListing.shortform.map<Promise<VideoQueueItemMeta>>(id => {
                return getMetadata(
                    id,
                    apiVideoListing.recommendationsAccountId,
                    services.config,
                    services.log
                )
            })
        )

        return {
            items: videoQueuePopulated,
            type: 'oovvuu-recommendation',
        }
    }

    return {
        items: shuffleArray(apiVideoListing.relatedVideos),
        type: 'topic-related',
    }
}
